import React from 'react';
import leticiaImage from '../assets/images/leticia-venancio.jpg';

const Instructor = () => {
  return (
    <section className="instructor">
      <div className="instructor-background-effects"></div>
      <div className="container">
        <div className="instructor-content">
          <div className="instructor-image">
            <img 
              src={leticiaImage} 
              alt="Letícia Venâncio"
              onError={(e) => {
                e.target.src = 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&h=800&fit=crop';
              }}
            />
          </div>
          
          <div className="instructor-info">
            <h2 className="instructor-title-large">QUEM SOU EU?</h2>
            <h4 className="instructor-name">LETÍCIA VENÂNCIO</h4>
            <p className="instructor-role">
                Oii, eu sou Letícia Venâncio..
            </p>
            <p>
            Sou especialista em sobrancelhas, atuando na área desde julho de 2019, e apaixonada por transformar vidas através do olhar.
            </p>
            <p className="instructor-stats">
              Atualmente, sou sócia proprietária da Clínica Bliss. Ao longo da minha trajetória na área da beleza, já realizei mais de <strong>10 mil atendimentos</strong>, acumulando uma experiência prática que vai muito além da teoria.

            </p>
            <p>
              Com base nessa vivência real do dia a dia, desenvolvi um método de ensino simples e aplicável, pensado para quem quer aprender Henna com segurança, clareza e resultados reais.<br />
            </p>
            <p>
              Hoje, minha missão é te ajudar a viver da estética com mais confiança, técnica e reconhecimento profissional, construindo uma base sólida para crescer na área da beleza.
            </p>
            <div className="instructor-decorative-text">LETÍCIA VENÂNCIO</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Instructor;

